import React from "react";
import LoginPageSection from "../sections/LoginPageSection/Content";
const LoginPage = () => {
  return <LoginPageSection />;
};

export default LoginPage;
